import React from 'react';

const DrawerHeader = ({ logo, title, ...props }) => (
    <div className="tw-drawer-header">
        <img src={logo} alt="Logo"/>
        <span>{title}</span>
    </div>
);

export default DrawerHeader;


// WEBPACK FOOTER //
// ./src/components/DrawerHeader.js